import React from "react";
import { Icon, IconProps } from "./Icon"; // Import the generic Icon component

export const ConfirmationQuestionIcon = (props: IconProps) => {
  return (
    <Icon
      classes={props.classes}
      height="24px"
      width="24px"
      viewBox="0 -960 960 960"
    >
      <path d="M120-320v-80h320v80H120Zm0-160v-80h480v80H120Zm0-160v-80h480v80H120Zm534 440L512-342l56-56 86 84 170-170 56 58-226 226Z" />
    </Icon>
  );
};
